import { render, staticRenderFns } from "./ramo.vue?vue&type=template&id=a66d8df6"
import script from "./ramo.vue?vue&type=script&lang=js"
export * from "./ramo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports